import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTerraformComponent } from './simple-icons-terraform.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTerraformComponent ],
    exports:      [ SimpleIconsTerraformComponent ],
    bootstrap:    []
})
export class SimpleIconsTerraformModule {}
